import React from 'react';

const InformationModal = ({ open, onClose, gameOption, totalAmount }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-[24rem] rounded-lg bg-white p-8 shadow-lg">
        <h2 className="mb-4 text-lg font-semibold text-gray-800">
          Information
        </h2>

        <div className="space-y-2 text-gray-700 font-bold text-lg">
          <div className="flex justify-between">
            <span>Game Option</span>
            <span className="">{gameOption?.gameType}</span>
          </div>

          <div className="flex justify-between">
            <span>Total Amount</span>
            <span className="">{totalAmount}</span>
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-6 w-full rounded-md bg-blue-600 py-2 text-white text-md hover:bg-blue-700 active:scale-[0.98]"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default InformationModal;
